import type { AllListingsListing } from '@b-stock/search-api-client'

import appConfig from '@config/config'
import { get } from '@helpers/xhr'

const { api } = appConfig

export interface RecommendedListingsParams {
  limit?: number
  offset?: number
}

export interface RecommendedListingsResponse {
  listings: AllListingsListing[]
  total?: number
}

export default {
  async fetchRecommendedListings(
    params: RecommendedListingsParams = {}
  ): Promise<RecommendedListingsResponse> {
    const { data } = await get<RecommendedListingsResponse>(
      `${api.search.allListings}/listings`,
      {
        sortBy: 'recommended',
        sortOrder: 'asc',
        listingType: 'SPOT',
        buyingFormat: 'AUCTION',
        offset: 0,
        ...params,
      }
    )
    return data
  },
}
